import React from 'react';
import PropTypes from 'prop-types';

const Text = ({content}) => {
    return (
        <div>
            {content.split("\n").map((line, key) => (
                <div key={key}>{line}<br/></div>
            ))}
        </div>
    );
};

Text.propTypes = {
    content: PropTypes.string.isRequired
}

export default Text;
